import { getKnowledgeByPath } from '@/redux/requests/skillsRequests.js';

const ONBOARDING_CHECKLIST_PATH = 'job/onboarding-checklist.md';

const fetchOnboardingChecklist = () => {
  getKnowledgeByPath({ path: ONBOARDING_CHECKLIST_PATH });
};

const handleOnboardingChecklistEvent = ({ rawToolName, rawToolPath }) => {
  if (rawToolName !== 'knowledge_write' || !rawToolPath.endsWith(ONBOARDING_CHECKLIST_PATH)) {
    return;
  }

  fetchOnboardingChecklist();
};

export { fetchOnboardingChecklist };
export default handleOnboardingChecklistEvent;
